<app-uni-page
  [parent]="this"
  *ngIf="isPageReady"
  pageTitle="References: Product Type Tags"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
></app-uni-page>
<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="horizontal" styleClass="h-full" [panelSizes]="[30, 70]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-child-actions">
          <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-plus" (click)="addProductTypeTag()">
            <span>Add Tag</span>
          </button>
        </div>
        <app-ag-grid
          [gridOptions]="ptTagGridOptions"
          [hasColSizeButtons]="false"
          [rowData]="productTypeTags"
          class="flex-1 min-h-0"
        ></app-ag-grid>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-child-actions">
          <button
            [disabled]="selectedProductTypeTag == null"
            pButton
            type="button"
            class="p-button-raised p-button-sm ml-4"
            icon="pi pi-link"
            (click)="attachProductTypes()"
          >
            <span>Attach Product Types to Selected Tag</span>
          </button>
        </div>
        <app-ag-grid
          [gridOptions]="ptTagMapGridOptions"
          [rowData]="productTypeTagMaps"
          class="flex-1 min-h-0"
        ></app-ag-grid>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
